export const acceptsCustomerBookings = (teamMember) => {
  if (!teamMember) return false;
  return teamMember.acceptsCustomerBookings !== false;
};

export const isAgendaVisibleTeamMember = (teamMember) => {
  if (!teamMember || teamMember.disabled) return false;
  return acceptsCustomerBookings(teamMember);
};

export const filterAgendaVisibleTeamMembers = (teamMembers) => (
  (Array.isArray(teamMembers) ? teamMembers : []).filter(isAgendaVisibleTeamMember)
);

export const isBookableTeamMember = (teamMember) => {
  if (!isAgendaVisibleTeamMember(teamMember)) return false;

  return Array.isArray(teamMember.services)
    && teamMember.services.some((service) => service && service.disabled !== true);
};

export const getBookableTeamMembers = (teamMembers) => (
  (Array.isArray(teamMembers) ? teamMembers : []).filter(isBookableTeamMember)
);
